import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect, Provider } from 'react-redux';

import {
  MovableCardWrapper,
  CardHeader,
  CardRightContent,
  CardTitle,
  Detail,
  Footer,
} from 'react-trello/dist/styles/Base';
import Tag from 'react-trello/dist/components/Card/Tag';
import DeleteButton from 'react-trello/dist/widgets/DeleteButton';
import {
  draftBackground,
  Total,
} from '../../../components/TaskListView/styles';
import styled from 'styled-components';
import SanitizedHTML from 'react-sanitized-html';
import MentionPop from '../../../components/MentionPop/MentionPop';
import { store } from '../../../index';
import { withTitle } from '../../../components/withTitle';
import TaskListView from '../../../components/TaskListView/TaskListView';
import { IAssignmentView } from '../../../store/tasks/tasksType';
import { display } from '../../../components/ErrorView/ErrorDialog';
import { appDispatch } from '../../../store/store';
import { markTaskAssignment } from '../../../store/tasks/tasksSlice';
import { border1 } from 'utils/style/colors';

const MyCardTitle = styled(CardTitle)`
  font-size: 12px !important ;
  font-weight: normal !important;
  overflow: hidden;
  display: flex;
`;
const MyCardHeader = styled(CardHeader)`
  border-bottom: ${border1} !important;
`;
const MyCardRightContent = styled(CardRightContent)`
  font-size: 12px !important ;
  font-weight: normal !important;
`;
const MyDetail = styled(Detail)`
  font-size: 15px !important ;
  font-weight: normal !important;
  border-top: 0 !important;
`;
const MyFooter = styled(Footer)`
  font-size: 15px !important;
  font-weight: normal !important;
  border-top: 0 !important;
`;
const MyMovableCardWrapper = styled(MovableCardWrapper)`
  display: inline;
  border-radius: 2rem;
  overflow: hidden;
  padding: 0 !important;

  & > div {
    margin: 1rem 0.5rem 0;
  }
`;
class Card extends Component {
  sentinelRef = createRef();
  observer = null;

  componentDidMount() {
    const { laneId, onLoadMoreTask } = this.props;

    const isLastCard = this.props?.isLastCard ?? false;

    if (!isLastCard || !this.sentinelRef.current) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && isLastCard) {
          onLoadMoreTask(this.props.id, laneId);
        }
      },
      {
        rootMargin: '150px',
      }
    );

    this.observer.observe(this.sentinelRef.current);
  }

  componentWillUnmount() {
    this.observer?.disconnect();
  }

  onDelete = (e) => {
    this.props.onDelete();
    e.stopPropagation();
  };

  handleUpdateAssignmentTask = async (assignment) => {
    try {
      await appDispatch(markTaskAssignment({ assignment: assignment }));
    } catch (err) {
      display(err);
    }
  };

  render() {
    const {
      //recently added
      task,
      thisUser,
      project,
      active,
      style,
      onClick,
      className,
      id,
      draft,
      companyId,
      projectId,
    } = this.props;

    const isLastCard = this.props?.isLastCard ?? false;
    return (
      <>
        <MyMovableCardWrapper
          data-id={id}
          onClick={onClick}
          style={style}
          className={className}
          draft={draft}
        >
          <Provider store={store}>
            <TaskListView
              task={task}
              thisUser={thisUser}
              template={task}
              thisUserId={Number(thisUser.userId)}
              companyId={companyId}
              projectId={projectId}
              showWeight={true}
              showProgress={false}
              templateSelected={true}
              project={project}
              active={active}
              windowSize="small"
              index={0}
              isHomePage={false}
              disableDroppable={true}
              onUpdateAssignment={this.handleUpdateAssignmentTask}
              onUpdateTask={(_) => {
                // unused body
              }}
              onClickOnTask={(id, tab = '') => {
                // unused body
              }}
            />
          </Provider>
        </MyMovableCardWrapper>
        {isLastCard && <div ref={this.sentinelRef} style={{ height: 1 }} />}
      </>
    );
  }
}

Card.propTypes = {
  showDeleteButton: PropTypes.bool,
  onDelete: PropTypes.func,
  onClick: PropTypes.func,
  style: PropTypes.object,
  tagStyle: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  label: PropTypes.string,
  description: PropTypes.string,
  tags: PropTypes.array,
};

Card.defaultProps = {
  showDeleteButton: true,
  onDelete: () => {
    /*do nothing*/
  },
  onClick: () => {
    /*do nothing*/
  },
  style: {},
  tagStyle: {},
  title: 'no title',
  description: '',
  label: '',
  tags: [],
  className: '',
};

export default connect(undefined, undefined)(Card);
